exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@keyframes fadeIn {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n.meta-editor input {\n  width: 100%; }\n\n.meta-editor button {\n  color: #30bced;\n  border-color: #30bced; }\n  .meta-editor button:hover {\n    background-color: #30bced;\n    color: white; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/StoryEditor/MetaEditor/MetaEditor.scss
// module id = 169
// module chunks = 0